<template lang="pug">
  b-modal(
    size="lg",
    v-model="value",
    header-class="lmm-common-popup-header",
    hide-footer)
    template(slot="modal-header")
      img(src="../../assets/admin_main_log.svg" style="height: 20px")
    b-container(fluid)
      div.context(v-if="device")
        p {{$t('remote.wol.desc', {device: device.alias})}}
        b-table(
          :busy.sync="isBusy",
          :items="devices",
          :fields="fields",
          :show-empty="true",
          :empty-text="$t('no-content')",
          thead-class="lmm-table-head",
          tbody-class="lmm-table-body",
          fixed)
          template(v-slot:cell(ip)="row")
            | {{row.item.s_pub_ip}} / {{row.item.s_pri_ip}}
          template(v-slot:cell(action)="row")
            b-button(size="sm", variant="primary", @click="sendWOLSignal(row.item)") {{$t('remote.wol.title')}}
      div.buttons
        b-btn(
          ref="close",
          size="sm",
          class="float-right",
          @click="close"
        ) {{$t('cancel')}}
</template>

<script>
import {RemoteAPI} from '@/api'
export default {
  name: 'wol-dialog',
  props: ['value', 'device'],
  watch: {
    device (n) {
      this.isBusy = true
      let params = {
        type: 'wol_list'
      }
      RemoteAPI.put(this.device.guid, params)
        .then(resp => {
          const {data} = resp
          if (!data.objects) {
            this.mac_addr = null
            this.devices = []
          } else {
            this.mac_addr = data.objects.mac_addr
            this.devices = data.objects.objects
          }
          this.isBusy = false
        })
    }
  },
  methods: {
    sendWOLSignal (dev) {
      this.isBusy = true
      let params = {
        type: 'wol',
        data: this.mac_addr
      }
      RemoteAPI.put(dev.device_id, params)
        .then(resp => {
          this.$awn.success(this.$t('remote.wol.success'))
          this.close()
        })
    },
    close () {
      this.$emit('input', false)
    }
  },
  data () {
    return {
      isBusy: false,
      mac_addr: null,
      devices: [],
      fields: [
        {
          key: 'device_name',
          label: this.$t('device'),
          tdClass: 'text-center',
          thClass: 'text-center',
          sortable: false
        },
        {
          key: 'ip',
          label: 'IP',
          tdClass: 'text-center',
          thClass: 'text-center',
          sortable: false
        },
        {
          key: 'action',
          label: ' ',
          tdClass: 'text-center',
          thClass: 'text-center',
          sortable: false
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped src="./dialogs.scss"></style>
